import type { AppointmentStatusCode } from "@/types/appointment";

/** What the backend counts as a pending appointment: booked, not yet attended. */
export const PENDING_APPOINTMENT_STATUSES: AppointmentStatusCode[] = [
  "AWAITING_CONFIRMATION",
  "SCHEDULED",
];

/**
 * Every other status: the appointment was attended, missed or canceled. These
 * are the rows of a pet's service history.
 */
export const PAST_APPOINTMENT_STATUSES: AppointmentStatusCode[] = [
  "CHECKED_IN",
  "IN_PROGRESS",
  "CHECKED_OUT",
  "AWAITING_PAYMENT",
  "DONE",
  "MISSED",
  "CANCELED",
];

/** Checked in or later, and not undone: the appointments with clinical data. */
export const ATTENDED_APPOINTMENT_STATUSES: AppointmentStatusCode[] = [
  "CHECKED_IN",
  "IN_PROGRESS",
  "CHECKED_OUT",
  "AWAITING_PAYMENT",
  "DONE",
];
